import Dashboard from './dashboard.container';

export default Dashboard;
